import { Alert } from 'loyal-react'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

class AlertErrorMessage extends Component {
  constructor (props) {
    super(props)
    this.state = { errorMessage: null }
    this.close = this.close.bind(this)
  }
  componentDidUpdate () {
    if ((this.props.errorMessage && this.props.errorMessage !== '') || (this.props.title && this.props.title !== '')) {
      this.state.errorMessage = this.props.errorMessage
      this.state.title = this.props.title
      this.props.filledState()
    }
  }

  close () {
    this.setState({ errorMessage: null })
    if (this.props.onClose) this.props.onClose()
  }

  render () {
    return this.state.errorMessage ? (
      <div className='row mb-4'>
        <Alert
          isError
          title={this.state.title ? this.state.title : 'Erro'}
          description={this.state.errorMessage}
          onClose={this.close}
        />
      </div>
    ) : (
      ''
    )
  }
}

AlertErrorMessage.propTypes = {
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  filledState: PropTypes.func,
  onClose: PropTypes.func
}

export default AlertErrorMessage



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/AlertErrorMessage.js